import { FC } from 'react';
import Stack, { StackProps } from '@mui/material/Stack';

interface ColumnProps extends StackProps {}

const Column: FC<ColumnProps> = (props) => {
    return <Stack direction="column" gap={3} width="100%" {...props} />;
};

export type { ColumnProps };
export default Column;
